import { getStatusColor } from '@bechtel/ht-clients-common';
import { FC } from 'react';
import { StatIndicatorStyled } from './styled';

export interface StatIndicatorProps {
  status: any;
  children?: React.ReactNode;
}

export const StatIndicator: FC<StatIndicatorProps> = ({ status, children }) => {
  return <StatIndicatorStyled color={getStatusColor(status)}>{children}</StatIndicatorStyled>;
};
